import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
var PublicTemplate = function (_a) {
    var children = _a.children;
    return (_jsx("div", { className: "c-app flex-row align-items-center", children: _jsx("div", { className: "container", children: _jsx("div", { className: "justify-content-center row", children: children }) }) }));
};
export default PublicTemplate;
